import queryString from 'query-string';

export default function getPathWithSearch(route, queryParams) {
  const search = queryString.stringify(queryParams, { skipEmptyString: true });

  return {
    pathname: route,
    search:   search ? `?${search}` : '',
  };
}
